import { CircleGeometry, Mesh, MeshBasicMaterial } from "three";
import { Default } from "../../Utils/Default.js";
export class Point extends Mesh {
    constructor(name, color, position, scaleByCalibration = true, scale = 1) {
        super(Point.geometry, new MeshBasicMaterial({ color: color, transparent: true, opacity: 0.5 }));
        this.name = name;
        position && this.position.copy(position);
        this.interceptedByRaycaster = false;
        if (scaleByCalibration) {
            Default.scaleByScaleFactorPoints(this);
        }
        else {
            this.scale.multiplyScalar(scale);
        }
    }
}
Point.geometry = new CircleGeometry(1, 15);
//# sourceMappingURL=Point.js.map